// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteSignUp__container___li3EB darkPage__darkPage___HYDOP","logo":"InviteSignUp__logo___a4IBZ logo__logo___oPoOM"};